var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BrandCategoryMapping',{on:{"getList":_vm.getList}}),_c('BrandMappingList',{attrs:{"brandList":_vm.brandList,"brandListTotal":_vm.brandListTotal,"offset":_vm.offset,"limit":_vm.limit},on:{"getList":_vm.getList,"changeOffset":_vm.updateOffset}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }